import Vue from 'vue';

// Import dayjs locale
import 'dayjs/locale/fr';

import '@cnamts/vue-dot/dist/vue-dot.css';
import VueDot from '@cnamts/vue-dot';

// Import the theme styles
import '@/theme/theme.scss';
import '@/theme/aat.scss';
import icons from '@/theme/icons';

// Register v-facade directive
import InputFacade from 'vue-input-facade';
const optionsVfacade = {
	// use these tokens instead of the default
	tokens: {
		// default ones
		'#': { pattern: /\d/ },
		'X': { pattern: /[0-9a-z]/i },
		'S': { pattern: /[a-z]/i },
		'A': { pattern: /[a-z]/i, transform: (v: string) => v.toLocaleUpperCase() },
		'a': { pattern: /[a-z]/i, transform: (v: string) => v.toLocaleLowerCase() },
		'\\': { escape: true },
		// custom one
		'N': { pattern: /[0-9a-z]/i, transform: (v: string) => v.toLocaleUpperCase() },
		'M': { pattern: /['+-:àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœa-zA-Z0-9 ]/i,
			transform: (v: string) => v.toLocaleUpperCase() }
	}
};
Vue.use(InputFacade, optionsVfacade);

Vue.use(VueDot, {
	theme: {
		icons
	}
});
